import { Component, OnInit } from '@angular/core';

import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { UserService } from './services/user.service';

// public class FileProvider extends androidx.core.content.FileProvider
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit {
  public selectedIndex = 0;
  public accessEntrega = true;
  public accessCheckin = true;
  public appPages = [
    {
     title: 'Perfil',
     url: '/profile',
     icon: 'person-circle',
     canAccess: true
    },
    {
      title: 'Entrega',
      url: '/entrega',
      icon: 'car',
      canAccess: false
    },
    {
      title: 'Check-in',
      url: '/checkin',
      icon: 'golf',
      canAccess: false

    }
  ];

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    public userS: UserService
  ) {
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
  }

  ngOnInit() {
    this.checkAccess();
  }

  checkAccess() {
    if (this.userS.user) {
      if (this.userS.user.acesso.entrega) {
        this.appPages[1].canAccess = true;
      } else {
        this.appPages[1].canAccess = false;
      }

      if (this.userS.user.acesso.checkin) {
        this.appPages[2].canAccess = true;
      } else {
        this.appPages[2].canAccess = false;
      }
    }
  }
}
